const blogSelectors = {

};

class templateBlogJS {
    constructor() {
        this.blogPage = document.querySelector("[blog-page]");
        this.blogPage.querySelector("#BlogTagFilter").addEventListener("change",(event)=>{
           this.filterData(event);
        });

    }
    filterData(event){
        let currentEle = event.currentTarget;
        currentEle = currentEle.value;
        location.href = currentEle;
    }
}

typeof templateBlogJS !== 'undefined' && new templateBlogJS();
